// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"jgp-t8lrI"};